module.exports = __webpack_public_path__ + "static/tsc-logo-white-4f9fd02050f3985b9d25e1ed67cdaf9a.svg";